export default __webpack_public_path__ + "static/media/qrcode-site.4ceb9f63.png";